/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { VideoMeetingProvider } from './videoMeetingProvider';

export type AppointmentSlotVideoMeetingProvider = VideoMeetingProvider | null;
